<form [formGroup]="formGroup">
    <app-simple-select-value-accessor
            label="Sposób przekazania załącznika"
            [data]="TYPES"
            formControlName="type"
            (selected)="onSelect($event)">
    </app-simple-select-value-accessor>
    <app-simple-file-select *ngIf="hasFile" formControlName="file" label="Załącznik" color="accent" accept="application/pdf">
    </app-simple-file-select>
</form>